import { isNil } from 'lodash';

import { CallList, EntityStatsChunk, formatDuration } from '@pwp-common';

import { createReportRow } from '../create-report-row/create-report-row';
import { createValuesForEntityStats } from '../create-values-for-entity-stats/create-values-for-entity-stats';
import { AdminReportCallStatsRowInput, ReportRow } from '../interfaces';

const getFormattedDuration = (statsChunk: EntityStatsChunk, callList: CallList): string => {
  const holdTime = statsChunk.getCalls(callList)?.avgHoldTimeForCallersThatHungUpEarlyMS();

  return isNil(holdTime) ? undefined : formatDuration(holdTime);
};

export const createAverageHoldTimeForCallersThatHungUpEarlyRow = ({
  entityStats,
  callList,
}: AdminReportCallStatsRowInput): ReportRow =>
  createReportRow(
    'averageHoldTimeForCallersThatHungUpEarly',
    createValuesForEntityStats(entityStats, (statsChunk) => getFormattedDuration(statsChunk, callList)),
    { callList },
  );
